// hooks/useIsMobile.js
import { useState, useEffect, useCallback } from "react";

/**
 * 自定义 Hook：判断是否为移动端
 * @param {number} breakpoint - 移动端分界像素（默认 768）
 * @returns {boolean} 是否为移动端
 */
export const useIsMobile = (breakpoint = 768) => {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth <= breakpoint;
  });

  // 防抖处理
  const handleResize = useCallback(() => {
    let timer = null;
    return () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        setIsMobile(window.innerWidth <= breakpoint);
      }, 200);
    };
  }, [breakpoint]);

  useEffect(() => {
    const resizeHandler = handleResize();
    window.addEventListener("resize", resizeHandler);
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [handleResize]);

  return isMobile;
};
